import React, {useState} from 'react';
import {
    Box,
    Button,
    CardActions,
    Container,
    FormControlLabel,
    Grid,
    Modal, Paper,
    Switch, Tab,
    Tabs,
    Typography
} from "@material-ui/core";
import LeadSourceRows from "./LeadSourceRows";

const LeadSourceCard = ({ classes, data, cardClasses}) => {
    const [viewIds, setViewIds] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [open, setOpen] = useState('');
    const handleSources = (obj) => {
        const {attributeType, sources} = obj;
        if (!sources.trafficSource.length) {
            setSelectedTab(1);
        }
        setOpen(`${attributeType}_${sources.type}`);
    };

    const handleTabClick = (e, val) => {
        setSelectedTab(val);
    };

    const handleClose = () => {
        setOpen('');
        setViewIds(false);
        setSelectedTab(0);
    };

    const { attributeType, type, description } = data;

    const exclusive = description.find(el => el.value.startsWith('exclusive='))
    let exclusiveBlurb = null
    if (typeof exclusive != 'undefined') {
        if (type === 'INCLUDE') {
            exclusiveBlurb = 'Allow All Exclusive Traffic';
        } else if (type === 'EXCLUDE') {
            exclusiveBlurb = 'Block All Exclusive Traffic';
        }
    }

    const hosted = description.find(el => el.value.startsWith('hosted='))
    let hostedBlurb = null
    if (typeof hosted != 'undefined') {
        if (type === 'INCLUDE') {
            hostedBlurb = 'Allow All Hosted Traffic';
        } else if (type === 'EXCLUDE') {
            hostedBlurb = 'Block All Hosted Traffic';
        }
    }

    const affiliateLength = data.sources.affiliateSource.length;
    const referringSiteUrlsLength = data.sources.referringSiteUrls.length;
    const trafficSourceLength = data.sources.trafficSource.length;
    return (
        <>
            { exclusiveBlurb != null ? (
                <Typography
                    variant="body2"
                    paragraph
                    style={{ marginBottom: '5px'}}
                >
                    { exclusiveBlurb }
                </Typography>
            ) : null }
            { hostedBlurb != null ? (
                <Typography
                    variant="body2"
                    paragraph
                    style={{ marginBottom: '5px'}}
                >
                    { hostedBlurb }
                </Typography>
            ) : null }
            <CardActions>
                <Button
                    variant="contained"
                    disableElevation
                    onClick={() => handleSources({
                        sources: data.sources,
                        attributeType
                    })}
                >
                    View Sources
                </Button>
            </CardActions>
            { open !== '' ? (
                <Modal
                    open={open !== ''}
                    onClose={handleClose}
                >
                    {open === `${attributeType}_${data.sources.type}` ? (
                        <Container className={classes.modal} maxWidth={false}>
                            <Grid container spacing={2}>
                                <Grid container spacing={2} alignItems="center"
                                      justify="space-between">
                                    <Grid item xs={6}>
                                        <Typography variant="h6">{attributeType}</Typography>
                                        <Typography variant="body1">
                                            Type: {type}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Tabs
                                        aria-label="raw data tabs"
                                        value={selectedTab}
                                        onChange={handleTabClick}
                                        indicatorColor="secondary"
                                    >
                                        <Tab
                                            label="Traffic Sources"
                                            disabled={!trafficSourceLength}
                                        />
                                        <Tab
                                            label="Affiliates"
                                            disabled={!affiliateLength}
                                        />
                                        <Tab
                                            label="Referring Site Urls"
                                            disabled={!referringSiteUrlsLength}
                                        />
                                    </Tabs>
                                    <Paper
                                        className={`${cardClasses.paper} ${cardClasses.leadSourcePaper}`}>
                                        <Box
                                            component="div"
                                            role="tabpanel"
                                            hidden={selectedTab !== 0}
                                        >
                                            <LeadSourceRows
                                                arr={trafficSourceLength ? data.sources.trafficSource : []}
                                                type="trafficSource"
                                                cardClasses={cardClasses}
                                            />
                                        </Box>
                                        <Box
                                            component="div"
                                            role="tabpanel"
                                            hidden={selectedTab !== 1}
                                        >
                                            <LeadSourceRows
                                                arr={affiliateLength ? data.sources.affiliateSource : []}
                                                type="affiliate"
                                                cardClasses={cardClasses}
                                            />
                                        </Box>
                                        <Box
                                            component="div"
                                            role="tabpanel"
                                            hidden={selectedTab !== 2}
                                        >
                                            <LeadSourceRows
                                                arr={referringSiteUrlsLength ? data.sources.referringSiteUrls : []}
                                                type="referringSiteUrls"
                                                cardClasses={cardClasses}
                                            />
                                        </Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Container>
                    ) : <div></div>}
                </Modal>
            ) : null}
        </>
    );
}

export default LeadSourceCard;
